import React from 'react';
import { Tab } from "@mui/material";

export const getTabsByRole = (cns, mnr, reports) => {
    let cnsRole = cns;
    let mnrRole = mnr;
    let cnsAndMNR = cns && mnr;
    const tabs = [];

    if (cnsRole || cnsAndMNR) {
        tabs.push(
            <Tab
                key="pa"
                label="PA Extensions"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />,
            <Tab
                key="rejected"
                label="Rejected Extensions"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />,
            <Tab
                key="config"
                label="Configurations"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />
        );
    }

    if (mnrRole || cnsAndMNR) {
        tabs.push(
            <Tab
                key="mnr"
                label="MNR Data"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />
        );
    }

    if (reports) {
        tabs.push(
            <Tab
                key="reports"
                label="Reports"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />,
            <Tab
                key="cocaAnnual"
                label="COCA Annual"
                style={{
                    fontSize: 'var(--font-size-header)',
                    fontFamily: 'var(--font-family-base)',
                }}
                sx={{
                    color: '#fff',
                    '&.Mui-selected': {
                        color: 'var(--secondary-color)',
                    },
                }}
            />
        );
    }

    return tabs;
};
